import NBType, { InferType } from '@netbase/nb-type'
import Scope from '../enums/Scope'

const ScopedStringListSchema = NBType.object().shape('ScopedStringListSchema', {
  /* @prop */
  scope: NBType.enum(Scope),
  /* @prop */
  terms: NBType.array().of(NBType.string())
  /* END */
})
export default ScopedStringListSchema
export type ScopedStringList = InferType<typeof ScopedStringListSchema>
// RESERVE BELOW
